"use client"

import * as React from "react"
import { cn } from "@/lib/utils"
import { useTerminalMode } from "@/hooks/use-terminal-mode"

export function MainCard({ className, ...props }: React.ComponentProps<"div">) {
  const { isTerminalMode } = useTerminalMode()

  return (
    <div
      data-slot="main-card"
      className={cn(
        "rounded-sm shadow-none transition-all duration-200",
        isTerminalMode
          ? "border bg-[var(--ast-brand-night)] text-[var(--ast-brand-green)] border-[color:rgba(var(--ast-brand-green-rgb),0.3)] hover:border-[color:rgba(var(--ast-brand-green-rgb),0.6)] hover:shadow-[0_0_15px_rgba(var(--ast-brand-green-rgb),0.15)]"
          : "bg-sidebar text-sidebar-foreground border border-sidebar-border",
        className
      )}
      {...props}
    />
  )
}

export function MainCardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="main-card-header" className={cn("px-4 py-3", className)} {...props} />
  )
}

export function MainCardTitle({ className, ...props }: React.ComponentProps<"div">) {
  const { isTerminalMode } = useTerminalMode()

  return (
    <div
      data-slot="main-card-title"
      className={cn(
        "text-sm font-semibold",
        isTerminalMode && "text-[var(--ast-brand-text)]",
        className
      )}
      {...props}
    />
  )
}

export function MainCardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div data-slot="main-card-content" className={cn("px-4 pb-4", className)} {...props} />
  )
}


